import { render, staticRenderFns } from "./MigrateDialog.vue?vue&type=template&id=1a40a80d&scoped=true&"
import script from "./MigrateDialog.vue?vue&type=script&lang=js&"
export * from "./MigrateDialog.vue?vue&type=script&lang=js&"
import style0 from "./MigrateDialog.vue?vue&type=style&index=0&id=1a40a80d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a40a80d",
  null
  
)

export default component.exports